import { Entidade } from '@elotech/components';
import { EntidadeServiceInterface } from 'common/type';

import {
  changeEntidade,
  extractEntidadeFromPath,
  isEntidadeNaoResolvida
} from './BaseHref';
import { setBaseHrefEntidadeCookie } from './EntidadeStorageUtils';
import {
  dispatchGlobalError,
  isAccessDeniedError
} from './UserPermissionsUtils';

export const EntidadeLogadaUtils = {
  getCurrent(defaultId: number = 1): string | number {
    return extractEntidadeFromPath()?.idEntidade ?? defaultId;
  },

  getCurrentOrPrincipal(
    service: EntidadeServiceInterface
  ): Promise<Entidade | undefined> {
    const { idEntidade = '0' } = extractEntidadeFromPath() ?? {};
    const buscarEntidade = isEntidadeNaoResolvida(idEntidade)
      ? service.findPrincipal
      : () => service.findById(Number(idEntidade));

    return buscarEntidade()
      .then(({ data }) => data)
      .catch(error => {
        if (!isAccessDeniedError(error)) {
          dispatchGlobalError(error);
        }
        return undefined;
      });
  },

  getCurrentOrRedirectToPrincipal(
    service: EntidadeServiceInterface,
    onAccessError: (denied: boolean) => void = () => undefined,
    applyResolvedId: (id: string | number) => void = changeEntidade
  ) {
    const { idEntidade = '0' } = extractEntidadeFromPath() ?? {};
    const handleError = error => {
      const denied = isAccessDeniedError(error);
      onAccessError(denied);
      if (!denied) {
        dispatchGlobalError(error);
      }
      return { data: undefined };
    };

    if (isEntidadeNaoResolvida(idEntidade)) {
      return service
        .findPrincipal()
        .then(response => {
          const idResolvido = response.data?.id;
          // Sem o guard, um id ausente ou igual ao placeholder navegaria para a
          // mesma URL, recarregando e refazendo a busca em loop infinito.
          if (idResolvido && !isEntidadeNaoResolvida(idResolvido.toString())) {
            setBaseHrefEntidadeCookie(idResolvido);
            applyResolvedId(idResolvido);
          }
          return response;
        })
        .catch(handleError);
    }

    return service.findById(Number(idEntidade)).catch(handleError);
  },

  onChangeEntidade(
    entidade: Entidade,
    onEntidadeChanged: (entidade: Entidade) => void
  ): void {
    const { idEntidade: entidadeAtual } = extractEntidadeFromPath() ?? {};

    if (entidade?.id && entidade.id.toString() !== entidadeAtual) {
      setBaseHrefEntidadeCookie(entidade.id);
      onEntidadeChanged(entidade);
      changeEntidade(entidade.id);
    }
  }
};
